export const CONTEXTES_AUDIT = [
    { value: "restructuration", label: "Restructuration & Procédures Collectives (Mandat ad hoc, Sauvegarde, RJ, Liquidation)" },
    { value: "ma_due_diligence", label: "M&A - Due Diligence (Acquisition / Cession)" },
    { value: "valorisation", label: "Valorisation d'entreprise" },
    { value: "transmission", label: "Transmission & Succession" },
    { value: "performance_bfr", label: "Audit de Performance & BFR" },
    { value: "creation_entreprise", label: "Création d'entreprise" },
    { value: "recherche_financement", label: "Recherche de financement (Banque / Subvention)" },
    { value: "nouveau_plan_developpement", label: "Nouveau plan de développement" },
    { value: "autre", label: "Autre (Préciser)" },
];
const LEGACY = { difficulte: "restructuration", prevention: "restructuration", ma: "ma_due_diligence", cession: "ma_due_diligence", acquisition: "ma_due_diligence", succession: "transmission" };
export const normContexte = (v) => LEGACY[v] || v;
export const isRestructuration = (v) => normContexte(v) === "restructuration";

export function labelContexte(v) {
    return CONTEXTES_AUDIT.find((c) => c.value === normContexte(v))?.label ?? v ?? "Non renseigné";
}

export const DOC_HELP = {
    fec: "Au moins 3 ans de FEC, idéalement 10 ans (CSV / TXT, un fichier par exercice).",
    liasse_fiscale: "Liasses 2050-2059 ou 2033 : bilan et compte de résultat de chaque exercice (PDF).",
    balance_clients: "Balance âgée clients à la dernière clôture : indispensable pour le BFR et le recouvrement.",
    balance_fournisseurs: "Balance âgée fournisseurs à la dernière clôture : dettes échues et tensions de paiement.",
    tableau_amortissements: "Tableau des dotations et VNC : nécessaire pour reconstituer l'actif économique.",
    valorisation_immobilisations: "État des immobilisations (valeur brute, amortissements, VNC) et éventuelles expertises.",
    rib: "RIB de chaque compte bancaire de l'entreprise (identité bancaire : IBAN, domiciliation).",
    releve_bancaire: "Relevés des 12 derniers mois pour rapprocher la trésorerie du FEC.",
    identite_gerant: "Pièce d'identité en cours de validité du/des gérant(s) — CNI ou passeport (Formulaire DCP).",
    kbis: "Extrait K-Bis de moins de 3 mois (Formulaire DCP).",
    etat_privileges: "État des privilèges et nantissements délivré par le greffe du tribunal de commerce.",
    fiches_paie: "Fiches de paie des 6 derniers mois (masse salariale et cotisations).",
    tableau_stocks: "Inventaire valorisé à la clôture, méthode de valorisation.",
    jugement: "Jugement d'ouverture / de conversion rendu par le tribunal (procédure collective).",
    pv_ag: "Procès-verbaux d'Assemblée Générale (ordinaire / extraordinaire) et décisions des associés.",
    statuts: "Statuts à jour de la société (version signée et enregistrée).",
    attestations_fiscales_sociales: "Attestations de régularité fiscale (DGFiP) et sociale (URSSAF) récentes.",
    tableau_amortissement_pret: "Tableau d'amortissement des emprunts bancaires en cours (échéancier capital / intérêts).",
    devis_fournisseurs: "Au moins 3 devis fournisseurs comparatifs pour l'investissement envisagé.",
    devis_cabinet_conseil: "Devis du cabinet de conseil / d'accompagnement (facultatif).",
    logo: "Logo de l'entreprise (formats vectoriel ou haute définition) pour les livrables.",
    photos: "Photos de l'activité, des locaux ou des produits.",
    entite_garantie_caution: "Documents d'entité garantie et actes de caution (personnelle ou solidaire).",
    autre: "Contrats, baux, attestations URSSAF, PV d'AG… tout document utile à l'analyse.",
};

// SUPER-LOT 103 Phase B / 104 — Sections documentaires (structure FLEXIBLE : ajouter une section = 1 entrée ici).
export const DOC_SECTIONS = [
    { key: "juridiques", label: "Juridiques & Administratifs", types: ["kbis", "identite_gerant", "statuts", "pv_ag", "jugement", "etat_privileges"] },
    { key: "banques", label: "Banques", types: ["rib", "releve_bancaire"] },
    { key: "comptables", label: "Comptables & Financiers", types: ["fec", "liasse_fiscale", "balance_clients", "balance_fournisseurs", "tableau_amortissements", "valorisation_immobilisations", "tableau_stocks", "attestations_fiscales_sociales", "tableau_amortissement_pret", "devis_fournisseurs", "devis_cabinet_conseil"] },
    { key: "medias", label: "Médias", types: ["logo", "photos"] },
    { key: "garanties", label: "Garanties", types: ["entite_garantie_caution"] },
    { key: "autres", label: "Autres", types: ["fiches_paie", "autre"] },
];
// Ordre d'affichage global dérivé des sections (ordre = sections puis types).
export const ALL_TYPES = DOC_SECTIONS.flatMap((s) => s.types);
export function sectionOfType(type) {
    return DOC_SECTIONS.find((s) => s.types.includes(type))?.key ?? "autres";
}

const BASE = ["fec"];
const AUDIT = ["fec", "liasse_fiscale"];
const REQUIRED_BY_CONTEXTE = {
    restructuration: ["fec", "liasse_fiscale", "balance_clients", "balance_fournisseurs"],
    ma_due_diligence: ["fec", "liasse_fiscale", "tableau_amortissements", "valorisation_immobilisations"],
    valorisation: ["fec", "liasse_fiscale", "tableau_amortissements", "valorisation_immobilisations"],
    transmission: ["fec", "liasse_fiscale", "tableau_amortissements", "valorisation_immobilisations"],
    performance_bfr: ["fec", "liasse_fiscale", "balance_clients", "balance_fournisseurs", "tableau_stocks"],
    creation_entreprise: ["devis_fournisseurs"],
    recherche_financement: ["fec", "liasse_fiscale", "attestations_fiscales_sociales", "tableau_amortissement_pret", "devis_fournisseurs"],
    nouveau_plan_developpement: ["fec", "liasse_fiscale", "attestations_fiscales_sociales", "devis_fournisseurs"],
    autre: AUDIT,
};
// LOT 58 — Socle DCP/CERFA : documents administratifs & dirigeant obligatoires pour TOUS les contextes.
const ADMIN_DCP = ["identite_gerant", "kbis", "etat_privileges", "releve_bancaire", "fiches_paie"];

// Matrice PAR DÉFAUT des pièces requises (avant personnalisation par l'experte).
export function requiredTypes(contexteAudit, typeDossier) {
    const c = normContexte(contexteAudit);
    const base = (c && REQUIRED_BY_CONTEXTE[c]) || (typeDossier === "diagnostic_flash" ? BASE : AUDIT);
    // L'état des privilèges & nantissements + le jugement ne sont requis par défaut QUE pour les procédures collectives.
    const admin = isRestructuration(c) ? [...ADMIN_DCP, "statuts", "jugement"] : ADMIN_DCP.filter((t) => t !== "etat_privileges");
    return [...new Set([...base, ...admin])].filter((t) => ALL_TYPES.includes(t));
}

// SUPER-LOT 103 Phase B — pièces requises EFFECTIVES : surcharge par dossier (documents_requis) si fournie, sinon défaut.
export function effectiveRequired(contexteAudit, typeDossier, documentsRequis) {
    if (Array.isArray(documentsRequis)) return documentsRequis.filter((t) => ALL_TYPES.includes(t));
    return requiredTypes(contexteAudit, typeDossier);
}

export function buildChecklist(contexteAudit, typeDossier, documents = [], documentsRequis) {
    const req = new Set(effectiveRequired(contexteAudit, typeDossier, documentsRequis));
    return ALL_TYPES.map((type) => {
        const docs = documents.filter((d) => d.type_document === type);
        const extracted = docs.some((d) => d.contenu_extrait && String(d.contenu_extrait).trim());
        return { type, required: req.has(type), help: DOC_HELP[type], count: docs.length, present: docs.length > 0, extracted };
    }).sort((a, b) => Number(b.required) - Number(a.required));
}

// Checklist groupée par section (pour l'éditeur de cases à cocher). Conserve l'ordre DOC_SECTIONS.
export function buildChecklistSections(contexteAudit, typeDossier, documents = [], documentsRequis) {
    const req = new Set(effectiveRequired(contexteAudit, typeDossier, documentsRequis));
    return DOC_SECTIONS.map((s) => ({
        key: s.key,
        label: s.label,
        items: s.types.map((type) => {
            const docs = documents.filter((d) => d.type_document === type);
            const extracted = docs.some((d) => d.contenu_extrait && String(d.contenu_extrait).trim());
            return { type, required: req.has(type), help: DOC_HELP[type], count: docs.length, present: docs.length > 0, extracted };
        }),
    }));
}

export function checklistReady(items) {
    const req = items.filter((i) => i.required);
    return { ready: req.every((i) => i.present && i.extracted), missing: req.filter((i) => !i.present), notExtracted: req.filter((i) => i.present && !i.extracted) };
}
